import React from 'react';

import { Badge } from 'react-bootstrap';
import ImageGreenCircle from '../../images/green-circle.png';

const FptProgrammItemTag = (props) => {

    // Dieses Mapping entspricht 1:1 dem Mapping in Fpt-Portal!
    const mappings = {
        netzwerk: {
            label: 'Netzwerk',
            bg: "BadgeNetzwerk"
        },
        process: {
            label: 'Prozessautomation',
            bg: "BadgeProzessautomation"
        },
        sicher: {
            label: 'Sicherheit',
            bg: "BadgeSicherheit"
        },
        green: {
            label: 'Green',
            bg: "BadgeGreen"
        },
        robotik: {
            label: 'Robotik',
            bg: "BadgeRobotik"
        },
        control: {
            label: 'Steuerung',
            bg: "BadgeSteuerung"
        },
        ki: {
            label: 'AI ✨',
            bg: "BadgeKI"
        },
        produktion: {
            label: 'Produktion',
            bg: "BadgeProduktion"
        },
        maschinenbau: {
            label: 'Maschinenbau',
            bg: "BadgeProduktion"
        },
        sensor: {
            label: 'Sensorik',
            bg: "BadgeSensorik"
        },
        mess: {
            label: 'Messtechnik',
            bg: "BadgeSensorik"
        },
        digital: {
            label: 'Digitalisierung',
            bg: "BadgeDigital"
        },
        IoT: {
            label: 'IoT',
            bg: "BadgeIoT"
        },
    }

    const getBackground = (tag) => {
        if(!tag) return;        

        if (mappings[tag.trim()]) {
            return mappings[tag.trim()].bg;
        }   
        return "secondary";
    }

    const getLabel = (tag) => {
        if(!tag) return;

        if (mappings[tag.trim()]) {
            return mappings[tag.trim()].label;
        }
        return tag;
    }

    return (
        <>
            {props.tag &&
                props.tag === 'green' ?
                <img key={props.tag} src={ImageGreenCircle} height="30" alt="Green Automation" className='ImageGreenCircle' />
                :
                <Badge key={props.tag} bg={getBackground(props.tag)}>
                    {getLabel(props.tag)}
                </Badge>
            }
            <br />
        </>
    )
}

export default FptProgrammItemTag;